module.exports = __webpack_public_path__ + "assets/img/import.ae9bcc0c.svg";